/*
    upsale 1.0 
    builder file - shopify resident script 
    Created by: Ziv Emmet
*/

var upsale_params = {
    data:null,
    lastscroly:0,
    lastscroldir:'',
    slidehandle:'',
    stickyT:0,
    cart:null,
    max_straps_upsale_num:9,
    featured_product:{
        id:'',
        sku:'',
        image:'',
        messagetext:'',
        price:0,
        compareAtPrice:0,
        availableForSale:null,
        title:''
    }
}

var upsale913 = (function(){

    var this_ = this;
    
    var currentleft = 0;

    var current_text_object_index = 0;

    var current_item_id = 0;

    var current_item_obj = null;

    var cartevent = function(cart){
        
        upsale_params.cart = cart;

        process_lowersection();

        if (upsale_params.data.upsales_pt2Sfx1v881[0].straps.config.cart.enable == false){

            return;
        }

        var carthaswatches = false;

        var coll =  [];

        for (var t=0; t < cart.items.length; t++) {

            if (cart.items[t].product_type == 'Watches'){carthaswatches = true;}

            coll_ = getstrapscollectionbywatchsku(cart.items[t].sku)[0];

            coll = coll.concat(strapsupsale.collections[coll_]);

        }

        if (current_item_id != 0){

            upsale913.close(current_item_id,current_item_obj);
        }
        
        window.setTimeout(function(){
            
            displaystrapscart(coll);
            
        },2000);
        
    }
    
    var init = function(data){

        $( window ).resize(function() {

             var factor = $('.upsale-torgoen-productpage').width() / 4.9;

             //console.log(factor);

             $('.upsale-torgoen-productpage').css('font-size',factor + '%');

             var w = $('.upsale-torgoen-cart').width();

             if (w > 700){
                factor2 = 100;
             }
             else{

                factor2 = 120;
             }

             $('.upsale-torgoen-cart').css('font-size',factor2 + '%');

        });

        upsale_params.data = data;

        process(data);

    }
    

    // if watch sku (or part of it) appears in data.json get the appropriate collection to display from
    // if not search for the watch's tag for lugs_X and display the appropriate collection
    var getstrapscollectionbywatchsku = function(sku){

        var coll = '';
        var excludetags = '';

        $.each(upsale_params.data.upsales_pt2Sfx1v881[0].straps.collections, function(index,value){

            if (value.object_sku_group.split(',').length > 1){
                
                // more than one group
                
                var j = value.object_sku_group.split(',');
                
                for (var i=0; i<j.length; i++){

                    if (sku.toUpperCase().indexOf(j[i].toUpperCase().trim()) > -1 || sku.toUpperCase() == j[i].toUpperCase().trim()){

                        coll = value.collection;
                        excludetags = value.excludetags;
                        //console.log(j[i].toUpperCase().trim());
                        //console.log(coll);
                    }
                }
            }
            else
                {
            
                if (sku.indexOf(value.object_sku_group) > -1){

                    //console.log(value.object_sku_group);

                    coll = value.collection;
                    excludetags = value.excludetags;

                }
                else{

                    // get collection by product tag

                    var tags = $('#tag_cloud_').attr('tags');

                    if (tags.indexOf('lugs_') > -1){
                        var arr = tags.split(' ');

                        arr.forEach(function(a){

                            if (a.indexOf('lugs_') > -1){

                                var b = a.split('_')[1];

                                coll = b + 'mm-straps';
                            }

                        });

                    }

                }
            }


        });

       //console.log('>>' + coll);

       return [coll, excludetags];

    }

    var getstrapsbywatchsku = function(sku){

        var straps = [];
        
        //console.log(sku);
        
        $.each(upsale_params.data.upsales_pt2Sfx1v881[0].straps.collections, function(index,value){

            if (value.object_sku_group.split(',').length > 1){
                
                // more than one group
                
                var j = value.object_sku_group.split(',');
                
                for (var i=0; i<j.length; i++){
                    
                   
                    if (sku.indexOf(j[i].trim()) > -1){

                        //console.log(value.object_sku_group);

                        straps = value.straps.concat(straps);
                    }
                    
                    
                }
            }
            else
                {
            
                if (sku.indexOf(value.object_sku_group) > -1){

                    //console.log(value.object_sku_group);

                    straps = value.straps.concat(straps);
                }
            }

        });

        //console.log(straps);
        
        return straps;
        
    };
    
    var cartstatus = function(){

      var straps = [];    
        
      $.ajax({
        type: "GET",
        url: '/cart.js',
        dataType: 'JSON',
        data: {},
        success: function(response){

            var carthaswatches = false;
          
            var straps =  [];
               
            upsale_params.cart = response;

            for (var t=0; t < response.items.length; t++) {
              
                if (response.items[t].product_type == 'Watches'){carthaswatches = true;}
              
                st = getstrapsbywatchsku(response.items[t].sku);

                straps = st.concat(straps);
            }
            
            displaystrapscart(straps);
        }
      });

    }                

    var close = function(idarr,obj){
        
        $(obj).parent().removeClass('upsalemagnify');
        $(obj).parent().find('a.close').hide();
        $(obj).parent().find('a.magnify').show();
        $(obj).parent().find('.upsaletitle').hide();
        $('.upsale-torgoen-productpage').removeClass('mag');
        $('.strapscontainer_').css('left', currentleft + 'px');

        current_item_id = 0;
        current_item_obj = null;
    }
    
    var magnify = function(idarr,obj){
        
        current_item_id = idarr;
        
        current_item_obj = obj;

        if ($('.strapscontainer_').length > 0){

            currentleft = $('.strapscontainer_').position().left;

            $('.strapscontainer_').css('left', '0px');

        }

        if ($(obj).parent().hasClass('upsalemagnify')){
            
            upsale913.close(idarr,obj);
        }
        else{
            
            $('.upsale-torgoen-productpage').addClass('mag');
            $(obj).parent().addClass('upsalemagnify');
            $(obj).parent().find('a.close').show();
            $(obj).parent().find('a.magnify').hide();
            $(obj).parent().find('.upsaletitle').show();  
        }              
    }
    
    var addtocartshopify = function(idarray){
      if (idarray.length > 1){

          $.ajax({
          type: "POST",
          url: '/cart/add.js',
          dataType: 'JSON',
          data: {
            quantity: 1,
            id: idarray[0],
            properties: {
              strapMaterial: idarray[1],
              strapColor: idarray[2],
              lugsWidth: idarray[3],
              outletStatus: idarray[4],
              price: idarray[5],
              salePrice: idarray[6]
            }
          },
          success: function(response){
            aftercartadd(response);
          }});

      }

    }

    var aftercartupdate = function(response){

        ajaxifyShopify.cartUpdateCallback(response);

    }

    var aftercartadd = function(data){

      $.ajax({
        type: "GET",
        url: '/cart.js',
        dataType: 'JSON',
        data: {},
        success: function(response){

          ajaxifyShopify.cartUpdateCallback(response);

          window.setTimeout(function(){

            $('.cart-text-link a').trigger('click');

          },200);
        }
      });

    }

    var rightpress = function(){

        var width = $('.strapscontainer_').width();

        var unit = width/3.618;

        var left = $('.strapscontainer_').position().left;

        left = left - unit;

        if (-1*(left - unit) > width){left = 0;}

        $('.strapscontainer_').animate({'left':left}, 500, "swing", function(){});
    }

    var leftpress = function(){

        var width = $('.strapscontainer_').width();

        var unit = width/3.618;

        var left = $('.strapscontainer_').position().left;

        //console.log('leftposition: ' + left);

        left = left + unit - 0.1;

        //console.log('left = left + unit: ' + left);

        if (left > 0){left = -1*(unit*2)}

        //console.log('if (left > 0){left = -1*(unit*2)}: ' + left);   

        $('.strapscontainer_').animate({'left':left}, 500, "swing", function(){});
    }

    var displaystraps_productpage_bycollection = function(coll){

        if (coll[0] == '') {return;}

        var straps = [];
        
        var k1 = $("<div class='strapscontainer_'></div>");
        var nav = $("<div class='lft_'></div><div class='rgt_'></div>");
        
        $(".upsale-torgoen-productpage").append(k1);
        $(".upsale-torgoen-productpage").append(nav);
        $(".upsale-torgoen-productpage").animate({'height':'12em'},function(){});

        $(document).on("swipeleft", ".upsale-torgoen-productpage", function() {
            leftpress();
        });
        
        
        $(document).on("swiperight", ".upsale-torgoen-productpage", function() {
            rightpress();
        });  

        $('.upsale-torgoen-productpage > div.lft_').click(function(){
            leftpress();
        });

        $('.upsale-torgoen-productpage > div.rgt_').click(function(){
            rightpress();
        });

        if (typeof(strapsupsale.collections[coll[0]]) == 'undefined'){

            console.log(coll[0]);

            return;
        }

        // console.log(strapsupsale.collections[coll[0]]);
        // coll[0] == collection name

        var num = 0;

        strapsupsale.collections[coll[0]].forEach(function (item, index) {

          if (num  > upsale_params.max_straps_upsale_num - 1){
            return;
        }

        var params = {
             id: '', 
             sku: '',
             price:0,
             compare:0,
             image:[],
             title:'',
            prod_id: '',
            currency: '',
            strap_color: '',
            strap_material: '',
            prod_type: '',
            lugs_width: '',
            tags: [],
            outletStatus: '',
         }; 

        params.sku = item.variants[0].sku;
        params.id = item.variants[0].id;   
        params.image = item.images;
        params.title = item.title.replace('|',' '); 
        params.name = item.title;
        params.prod_id = item.id;
       params.prod_type = item.type;
       params.tags = item.tags;
        params.strapColor = item.properties.strap_color;
        params.strapMaterial = item.properties.strap_material;
        params.lugs_width = item.properties.lugs_width;
        params.outletStatus = item.properties.outletStatus;
        params.compare = item.properties.price;
        params.price = item.properties.salePrice;


        var ext = false;
        // coll[1] == string of exclude tags 
        if (coll[1] != ''){
            if (coll[1].indexOf(params.sku) > -1){
                ext = true;
                //console.log(params.sku + ' excluded' );
            }
        }

        /*
        console.log(params.price);
        console.log(params.compare);
        console.log(params.image);
        console.log(params.title);
        */

        if (!ext){

            //console.log(params.title);

            var hide = '';

              
            if  (params.price == params.compare) {
                 
                 hide = 'hide';
                 
            }  

            straps.push(params);  

            var currencysymbol = $('select[name=currency] option[selected=selected]').text().split(' ')[1];

            $(k1).append('<div id="pp'+params.id+'"  class="animated fadeIn delay-1s">' 
                        + '<div class="money price">'  
                        + '+' + currencysymbol + (params.price/100)
                        + '</div>' 
                        + '<div class="money compare '  + hide + '">'  
                        + currencysymbol + (params.compare/100)
                        + '</div>' 
                        + '<a class="add" href="javascript:void(0)">ADD</a>'
                        + '<img class="upsaleitemimage917" src="' + params.image[0] + '" />' 
                        + '<a class="magnify" href="javascript:void(0)"><img src="//cdn.shopify.com/s/files/1/2372/2167/files/mag.png?v=1627146865" alt=""></a>'
                        + '<a class="close" href="javascript:void(0)"><img src="//cdn.shopify.com/s/files/1/2372/2167/files/icon-close.svg?v=1627146865" alt=""></a>'
                        + '<div class="upsaletitle">' + params.title + '</div>'
                        + '</div>');

        
            $('#pp' + params.id + ' > a.add').click(function(){
                upsale913.addtocartshopify([params.id, params.strapMaterial, params.strapColor, params.lugs_width, params.outletStatus, params.compare, params.price])
                var strapColor = params.strapColor;
                var strapMaterial = params.strapMaterial;
                var lugsWidth = params.lugs_width;
                var saleStatus = params.outletStatus;
                var price = params.price / 100;
                var compDec = price.toFixed(2);
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                  event: 'add_to_cart',
                  ecommerce: {                          
                    items: [{
                      item_name: params.name,
                      item_id: params.prod_id.toString(),
                      currency: cartObj.currency,
                      price: compDec,
                      strap_color: strapColor,
                      strap_material: strapMaterial,
                      item_category: params.prod_type,
                      lugs_width: lugsWidth,
                      sale_status: saleStatus,
                      quantity: '1'
                    }]
                  }
                });

            });
            
            $('#pp' + params.id + ' > img.upsaleitemimage917').click(function(){

                upsale913.magnify([params.id],this);

            });
            
            $('#pp' + params.id + ' > a.magnify').click(function(){

                upsale913.magnify([params.id],this);

            });
            
            $('#pp' + params.id + ' > a.close').click(function(){

                upsale913.close([params.id],this);

            });

            $('#pp' + params.id).hover(function(){

                    $(this).find('.magnify').css('display','block');

            }, function () {
                    $(this).find('.magnify').css('display','none');    
            });

            num++;
        }
        
      });

    }

    var displaystrapscart = function(coll){
        
        // Shuffle Array
        const shuffled = coll.sort(() => 0.5 - Math.random());

        // Get sub-array of first n elements after shuffled
        let selected = shuffled.slice(0, 4);    

        var strapsout = [];

        var k1 = $("<div></div>");

        $(".upsale-torgoen-cart").append(k1);

        //console.log(selected);

        if (selected.length > 0){

            selected.forEach(function (item, index) {

                var params = {
                     id: '', 
                     price:0,
                     compare:0,
                     image:[],
                     title:'',
                  prod_id: '',
                  currency: '',
                  strap_color: '',
                  strap_material: '',
                  prod_type: '',
                  lugs_width: '',
                  tags: [],
                  outletStatus: ''
                 }; 

                 if (typeof(item) != 'undefined'){


                    params.id = item.variants[0].id;                               
                    params.compare = item.properties.price;
                    params.price = item.properties.salePrice;
                    params.image = item.images;
                    params.title = item.title.replace('|',' '); 
                    params.prod_id = item.id;
                    params.prod_type = item.type;
                    params.tags = item.tags;
                    params.strapColor = item.properties.strap_color;
                    params.strapMaterial = item.properties.strap_material;
                    params.lugs_width = item.properties.lugs_width;
                    params.outletStatus = item.properties.outletStatus;
                    //console.log(xml);    


                    var hide = '';
   
                      
                    if  (params.price == params.compare) {
                         
                         hide = 'hide';
                    }  

                    //var domain_ = upsale_ob.pathtoscript_common + '/apps/' + upsale_ob.app + '/admin';      

                    var currencysymbol = $('select[name=currency] option[selected=selected]').text().split(' ')[1];

                    $(k1).append('<div id="'+params.id+'"  class="animated flipInY delay-5s">' 
                            + '<div class="money price">'  
                            + currencysymbol + (params.price/100)
                            + '</div>' 
                            + '<div class="money compare ' + hide + '">'  
                            + currencysymbol + (params.compare/100)
                            + '</div>' 
                            + '<a class="add" href="javascript:void(0)">ADD</a>'
                            + '<img class="upsaleitemimage917" src="' + params.image[0] + '" />' 
                            + '<a class="magnify" href="javascript:void(0)"><img src="//cdn.shopify.com/s/files/1/2372/2167/files/mag.png?v=1627146865" alt=""></a>'
                            + '<a class="close" href="javascript:void(0)"><img src="//cdn.shopify.com/s/files/1/2372/2167/files/icon-close.svg?v=1627146865" alt=""></a>'
                            + '<div class="upsaletitle">' + params.title + '</div>'
                            + '</div>');


                    $('#' + params.id + ' > a.add').click(function(){
                        upsale913.addtocartshopify([params.id, params.strapMaterial, params.strapColor, params.lugs_width, params.outletStatus, params.compare, params.price]);

                      var strapColor = params.strapColor;
                      var strapMaterial = params.strapMaterial;
                      var lugsWidth = params.lugs_width;
                      var saleStatus = params.outletStatus;
                      var price = params.price / 100;
                      var compDec = price.toFixed(2);
                      window.dataLayer = window.dataLayer || [];
                      dataLayer.push({ ecommerce: null });
                      window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {                          
                          items: [{
                            item_name: params.title,
                            item_id: params.prod_id.toString(),
                            currency: cartObj.currency,
                            price: compDec,
                            strap_color: strapColor,
                            strap_material: strapMaterial,
                            item_category: params.prod_type,
                            lugs_width: lugsWidth,
                            sale_status: saleStatus,
                            quantity: '1'
                          }]
                        }
                      });


                    });

                    $('#' + params.id + ' > img.upsaleitemimage917').click(function(){

                        upsale913.magnify([params.id],this);

                    });

                    $('#' + params.id + ' > a.magnify').click(function(){

                        upsale913.magnify([params.id],this);

                    });

                    $('#' + params.id + ' > a.close').click(function(){

                        upsale913.close([params.id],this);

                    }); 

                    /*
                    var currencysymbol = $('select[name=currency] option[selected=selected]').text().split(' ')[1];
                    bundleValue   = parseFloat(Currency.convert(bundleValue, 'USD', $('select[name=currency]').val()));
                    bundleCompare = parseFloat(Currency.convert(bundleCompare, 'USD', $('select[name=currency]').val()));
                    */

                 }


            }); //end foreach
        }

    }

    var get_collection_by_sku = function(featured_sku, belong_to_collection_handle){

      var data = '' +
              '{shop {' +
                  'collectionByHandle(handle: "' + belong_to_collection_handle + '") {' +
                    'products(first:100) {' +
                      'edges {' +
                            'node {' + 
                              'title\n' +
                              'variants(first:100) {' +  
                                  'edges {' +
                                        'node {' + 
                                              'id\n' +
                                              'sku\n' +
                                              'title\n' +
                                              'compareAtPrice\n' +
                                              'price\n' +
                                              'availableForSale\n' +
                                              'image {' +
                                                  'id\n' +
                                                  'originalSrc\n' +
                                              '}' +
                                          '}' +
                                        '}' +
                                      '}' +
                                    '}' +
                                  '}' +
                                '}' +
                              '}' +
                            '}' +
                          '}';

      $.ajax({
        type: "POST",
        url: "https://torgoen-watches.myshopify.com/api/2019-07/graphql.json",
        //url:"https://torgoen-watches.myshopify.com/api/graphql",
        headers: {
              'X-Shopify-Storefront-Access-Token':"cb428c8a47b77a9e2ab6f67fe484b6e2",
              'Content-Type': "application/graphql"
        },  
        dataType: "JSON",
        data:data,
        success: function(response3){

                  process_feature_product(response3,featured_sku);
              }
        });
    }

    var draw_productpage_featured = function(){


        var txt = upsale_params.featured_product.messagetext;

        var a = $("<div class='upsale_featured_wrapper'><div>&nbsp;</div><div class='featured_img_wrapper'><img src='" + upsale_params.featured_product.image + "' /></div><div><div>" 
            + upsale_params.featured_product.messagetext 
            + "</div></div></div>");

        var l = $('<a class="add" href="javascript:void(0)">ADD</a>');

        var b = $('<div class="featured_money"><div class="price_wrap"><div class="money price">$' + upsale_params.featured_product.price + 
            '</div><div class="money compare">$' + upsale_params.featured_product.compareAtPrice + '</div></div><br/><div class="button_wrap"></div></div>');

        $('form[action="/cart/add"]').append(a);

        $('.upsale_featured_wrapper  > div:last-child').append(b);

        $('.upsale_featured_wrapper .button_wrap').append(l);

        $('.featured_img_wrapper').click(function(){

            if ($(this).width() > 200){
                $(this).animate({width:'25%'});
            }
            else{
                $(this).animate({width:'70%'});
            }
        });

        $(l).click(function(){

            p = atob(upsale_params.featured_product.id).split('/');
            id = p[p.length-1];

            addtocartshopify([id]);

        });

    }

    var process_feature_product = function(response3,featured_sku){

        //console.log(featured_sku);
        //console.log(response3);

        $(response3.data.shop.collectionByHandle.products.edges).each(function(index,val){

            if(val.node.variants.edges[0].node.sku == featured_sku){

                upsale_params.featured_product.availableForSale = val.node.variants.edges[0].node.availableForSale;
                upsale_params.featured_product.price = val.node.variants.edges[0].node.price;
                upsale_params.featured_product.compareAtPrice = val.node.variants.edges[0].node.compareAtPrice;
                upsale_params.featured_product.id = val.node.variants.edges[0].node.id;
                upsale_params.featured_product.title = val.node.title;

                //console.log(val.node.variants.edges[0].node);

                if (upsale_params.featured_product.availableForSale){

                    draw_productpage_featured();
                }
            }

        });

    }

    var displayupsalemessage = function(){

        if (upsale_params.data.upsales_pt2Sfx1v881[0].straps.config.product.messageenable){

            if (upsale_params.data.upsales_pt2Sfx1v881[0].straps.config.product.messagetext != ''){

                if ($('.upsale-torgoen-productpage > div').length >0){

                    $('.template-product .product-form-product').append($('<div class="product_upsale_text">' + upsale_params.data.upsales_pt2Sfx1v881[0].straps.config.product.messagetext + '</div>'));
                }
            }
        }
    }

    var getcart = function(callback){


      $.ajax({
        type: "GET",
        url: '/cart.js',
        dataType: 'JSON',
        data: {},
        success: function(response){
            upsale_params.cart = response;
             callback(response);

            }

        });
    }

    var evaluatetype = function(type, subject, qty, cartitems){

        // qty = ">0"
        var num = 0;

        $(cartitems).each(function(indx,val){


            //product_type == 'Wathces'
            if (val[type] == subject){

                num++;
            }

            /*
            console.log(val[type]);
            console.log(subject);
            console.log(num);
            */
        });


        // 1>0
        //console.log(subject);
        //console.log('result: ' + eval(num+qty));
        return eval(num+qty);

    }

    var featured_conditions_process = function(response){

        //console.log("featured_conditions_process");

        var result;
        var operator = upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config.conditions.show.operator;

        if (operator == "AND"){

            result = true;
        }

        if (operator == "OR"){

            result = false;
        }

        $(upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config.conditions.show.logic).each(function(indx,val){

            //console.log('>' + operator);

            if (val.condition == 'has item type'){

                if (operator == 'AND'){

                    result = result & evaluatetype('product_type', val.subject, val.qty, response.items);
                }

                if (operator == 'OR'){

                    result = result || evaluatetype('product_type', val.subject, val.qty, response.items);
                }
                
            }

        });

        //console.log('featured_conditions_process: ' + result);

        if (result){

            showlowermodule();

        }
        else{

            //console.log('>' + result);

            hidelowermodule();
        }

    }

    var featured_conditions = function(){

            var result = false;

            if ('conditions' in upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config){

                if ('show' in upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config.conditions){

                    if (upsale_params.cart == null){

                        getcart(featured_conditions_process);
                    }
                    else{

                        featured_conditions_process(upsale_params.cart);
                    }

                }

        }
    }

    var hidelowermodule = function(){

        $('.upsale_featured_wrapper').hide();
    }

    var showlowermodule = function(){

        if ($('.upsale_featured_wrapper').length > 0){

            $('.upsale_featured_wrapper').show();
        }

        else{


            var featured_sku = upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config.variant.sku; 
            var belong_to_collection_handle = upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config.variant.belong_to_collection_handle;
            var featured_product_image = upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config.productpage.image;
            var featured_product_messagetext = upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.config.productpage.messagetext; 

            upsale_params.featured_product.sku         = featured_sku;
            upsale_params.featured_product.image       = featured_product_image;
            upsale_params.featured_product.messagetext = featured_product_messagetext;


            get_collection_by_sku(featured_sku, belong_to_collection_handle); //get the collection containing the spesific variant

        }

    }

    var process_lowersection = function(data){

       if (isAnObject(meta)){
        
           if (meta.page.pageType == "product"){

                if ('lowerstrapsection' in upsale_params.data.upsales_pt2Sfx1v881[0]){

                    if (upsale_params.data.upsales_pt2Sfx1v881[0].lowerstrapsection.enable){

                        featured_conditions();

                    }
                }

           }
       }

    }

    var process = function(data){

       //return;    
        
       var straps = [];    
       var collection_name;
       var st = null;
        
       if (typeof(meta) != 'undefined'){

           if (isAnObject(meta)){
            
               if (meta.page.pageType == "product"){
                   
                    if (upsale_params.data.upsales_pt2Sfx1v881[0].straps.config.product.enable){

                        // and array with collection name and exlusion tags
                        collection_ = getstrapscollectionbywatchsku(meta.product.variants[0].sku);
                       
                        window.setTimeout(function(){

                            //console.log(collection_);

                            displaystraps_productpage_bycollection(collection_);

                            displayupsalemessage();

                        },100);

                    }
                   
               }   
           }

       }



       //console.log(data);

    }

    function isAnObject(obj)
    {
        if(obj==null) return false;
        return obj.constructor.name.toLowerCase() === "object"
    }
    

    return{

        init:init,
        cartevent:cartevent,
        addtocartshopify:addtocartshopify,
        magnify:magnify,
        close:close
    }

})();

            
upsale913.init(straps_upsale_json);




